import { Alert, AlertTitle } from "ra-friendsofbabba";
import React, { Fragment } from "react";
import { useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core";
import useStats from "../useStats";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  message: {
    fontSize: 17,
  },
}));

const UnaccountableWpAlert = ({ isNew, userId }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const { loading, wpDuration, contractMonth, totalMonths } = useStats(userId);
  const showWarningAlert = !(
    loading ||
    wpDuration <= 0 ||
    !isNew ||
    !contractMonth > 0
  );
  const showErrorAlert = totalMonths + contractMonth > 18;

  return (
    <Fragment>
      {showWarningAlert && (
        <Alert elevation={1} severity="warning" className={classes.root}>
          <AlertTitle>
            {translate("resources.user_breaks.alerts.unaccountable_wp.title")}
          </AlertTitle>
          <div
            className={classes.message}
            dangerouslySetInnerHTML={{
              __html: translate(
                "resources.user_breaks.alerts.warning.unaccountable_wp.message",
                {
                  wpDuration,
                }
              ),
            }}
          />
        </Alert>
      )}
      {showErrorAlert && (
        <Alert elevation={2} severity="error" className={classes.root}>
          <AlertTitle>
            {translate("resources.user_breaks.alerts.unaccountable_wp.title")}
          </AlertTitle>
          <div
            className={classes.message}
            dangerouslySetInnerHTML={{
              __html: translate(
                "resources.user_breaks.alerts.error.unaccountable_wp.message"
              ),
            }}
          />
        </Alert>
      )}
    </Fragment>
  );
};
export default UnaccountableWpAlert;
